module.exports = __webpack_public_path__ + "static/media/menu4x8t@1x.8aa88231.svg";